import { Service } from '@roc/feature-app-core';

const url = {
  SUBMIT_APPRAISAL: '/api/v1/roc-valuation/createStandaloneValuation',
  SUBMIT_LOAN_APPRAISAL: '/api/v1/loan/appraisal/submitLoanAppraisal',
  DOES_PIPELINE_LOAN_WITH_SAME_ADDRESS_EXISTS:
    '/api/v1/loan/appraisal/doesPipelineLoanWithSameAddressExists',
};

export class SubmitAppraisalService extends Service {
  submitAppraisal(form_information: any, ignored: File) {
    return this.post(url.SUBMIT_APPRAISAL, form_information);
  }

  submitLoanAppraisal(loanId: number, gfdPayment: boolean) {
    const endpointUrl = `${url.SUBMIT_LOAN_APPRAISAL}?loanId=${loanId}&gfdPayment=${gfdPayment}`;
    return this.post(endpointUrl, {});
  }

  doesPipelineLoanWithSameAddressExists(streetNumber: string, streetName: string, aptNumber: string, city: string, state: string, zipCode: string) {
    return this.get(url.DOES_PIPELINE_LOAN_WITH_SAME_ADDRESS_EXISTS, { streetNumber, streetName, aptNumber, city, state, zipCode });
  }
}
